import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { listCardTypes } from '../../api/cards'
import { cardTypesLoaded } from '../../reducers'

// The club's card types, for the menu: Cards shows once the club has one.
export const CardTypesLoader = ({ siteId }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        let current = true
        listCardTypes(siteId)
            .then(types => { if (current) dispatch(cardTypesLoaded(siteId, types)) })
            .catch(err => console.warn('Could not load the card types', err))
        return () => { current = false }
    }, [siteId])
    return null
}
